import Backbone from "backbone";
import * as _ from "underscore";

import * as mustcache from "mustcache";
import * as dateUtils from "shared/dateUtils";
import * as subscriptionPlans from "shared/subscriptionPlans";
import * as utils from "shared/utils";
import StripeCustomer from "StripeCustomer";

interface Data {
  user: any;
  expiryDateString: string;
  plans: any[];
  showCard: boolean;
  paymentMethod?: string;
  noStripeCustomer?: boolean;
}

const AccountSettingsView = Backbone.View.extend({
  initialize: function () {
    this.render();
  },
  render: function () {
    const user = this.model.toJSON();
    const data: Data = {
      user: this.model.toJSON(),
      expiryDateString: new Date(
        dateUtils.parse(this.model.get("subscriptionExpiryDate"))
      ).toDateString(),
      plans: this.getPlans(),
      showCard: user.renewalMonths > 0,
    };

    this.getPaymentMethod((paymentMethod) => {
      data.paymentMethod = paymentMethod;
      data.noStripeCustomer = this.stripeCustomer.noStripeCustomer;

      mustcache.render("accountSettings", data, (html) => {
        this.$el.html(html);
        this.$(".renewalMonths").val(String(this.model.get("renewalMonths")));
      });
    });
  },
  getPlans: function () {
    const user = this.model.toJSON();
    let monthOptions = [12, 1, 0];

    if (user.renewalMonths === 3) {
      monthOptions = [12, 3, 1, 0];
    }

    return _.map(monthOptions, (months) => {
      let plan;

      if (months === 0) {
        plan = {
          renewDescription: "Off",
          months: 0,
          price: 0,
        };
      } else {
        plan = subscriptionPlans.getPlanFromMonths(months) as any;

        if (months === user.renewalMonths) {
          if (user.price < plan.price) {
            plan.grandfatheredPrice = user.price;
          }
        }
      }
      if (months === user.renewalMonths) {
        plan.selected = true;
      }

      return plan;
    });
  },
  getPaymentMethod: function (callback) {
    switch (this.model.get("paymentMethod")) {
      case "paypal":
        callback({ paypal: true });
        break;
      case "stripe":
      case "coupon":
        this.stripeCustomer = new StripeCustomer(() => {
          const paymentMethod: any = {
            stripe: true,
          };

          const card = this.stripeCustomer.getDefaultCard();
          if (card) {
            paymentMethod.card = _.clone(card);
            paymentMethod.card.fundingString = utils.toTitleCase(
              paymentMethod.card.funding
            );
          }

          callback(paymentMethod);
        });
        break;
      default:
        callback({ none: true });
    }
  },
  events: {
    "click .changePaymentCard": "changePaymentCard",
    "change .renewalMonths": "changeRenewalMonths",
  },
  changePaymentCard: function () {
    // Redirect to Stripe checkout to change payment method
    window.location.href = "/api/stripe/createCheckoutPaymentMethodSession";
  },
  changeRenewalMonths: function () {
    const user = this.model.toJSON();
    let renewalMonths = this.$(".renewalMonths").val();
    if (typeof renewalMonths !== "number") {
      renewalMonths = parseInt(renewalMonths, 10);
    }

    this.$(".renewalMonths").replaceWith("Please wait. Updating...");

    if (renewalMonths === 0) {
      this.stripeCustomer.removeSubscription(() => {
        window.location.reload();
      });
    } else if (this.stripeCustomer.noStripeCustomer) {
      alert(
        "Please wait until your current subscription expires, then you'll be able to pay " +
          "to re-subscribe. Don't worry, all your data will still be saved to your account!"
      );
    } else {
      const plan: any = subscriptionPlans.getPlanFromMonths(renewalMonths);

      if (user.renewalMonths === 0) {
        this.stripeCustomer.createSubscription(
          plan.id,
          new Date(dateUtils.parse(this.model.get("subscriptionExpiryDate"))),
          () => {
            window.location.reload();
          }
        );
      } else {
        this.stripeCustomer.setPlan(plan.id, (err) => {
          if (err) {
            alert(
              "There was an error updating your subscription. Please contact steve@readlang.com."
            );
            return;
          }
          window.location.reload();
        });
      }
    }
  },
});

export default AccountSettingsView;
